module.exports = __webpack_public_path__ + "img/11-query-results.69bd06fb.png";